module.exports = __webpack_public_path__ + "static/media/amusement(1).c4a09c7a.PNG";